document.addEventListener('DOMContentLoaded', () => {
  const RUPEE = '\u20B9';
  const home = document.querySelector('.rt-home');
  if (!home) return;

  const defaultCity = home.dataset.defaultCity || 'Pune';
  const defaultMinutes = home.dataset.defaultMinutes || 'Check delivery time';
  const stickyBar = home.querySelector('[data-sticky-bar]');
  const stickyTitle = home.querySelector('[data-sticky-title]');
  const stickyText = home.querySelector('[data-sticky-text]');
  const deliveryTitle = home.querySelector('[data-home-delivery-title]');
  const deliverySubtitle = home.querySelector('[data-home-delivery-subtitle]');

  const variantModal = home.querySelector('[data-variant-modal]');
  const variantTitle = home.querySelector('[data-variant-title]');
  const variantList = home.querySelector('[data-variant-list]');

  const LOCATION_KEYS = [
    'rufftail_delivery_location_v4',
    'rufftail_delivery_location_v3',
    'rufftail_delivery_location_v2',
    'rufftail_delivery_location',
    'rf_delivery_location',
    'rf_location'
  ];

  const formatINR = (value) => {
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 0
      }).format(value);
    } catch (error) {
      return `${RUPEE}${value}`;
    }
  };

  const getSavedLocation = () => {
    for (let i = 0; i < LOCATION_KEYS.length; i += 1) {
      try {
        const raw = window.localStorage.getItem(LOCATION_KEYS[i]);
        if (!raw) continue;
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object') return parsed;
      } catch (error) {}
    }
    return null;
  };

  const getPuneDeliveryWindow = () => {
    return {
      title: '24 hour delivery',
      note: 'For selected Pune/PCMC location.'
    };
  };

  const isPuneDeliveryText = (timeText, addressText) => {
    const combined = `${timeText || ''} ${addressText || ''}`.toLowerCase();
    return (
      /mins?|minutes|hour|hours|hr|hrs/.test(combined) ||
      combined.includes('pune') ||
      combined.includes('pimpri') ||
      combined.includes('chinchwad') ||
      combined.includes('pcmc') ||
      combined.includes('24 hour') ||
      combined.includes('same day') ||
      combined.includes('next day')
    );
  };

  const isOuterPuneDeliveryText = (timeText, addressText) => {
    const combined = `${timeText || ''} ${addressText || ''}`.toLowerCase();
    return (
      /\b2\s*-\s*3 days?\b/.test(combined) ||
      combined.includes('outer pune') ||
      combined.includes('nearby maharashtra')
    );
  };

  const isNonPuneDayEta = (timeText, addressText) => {
    const combined = `${timeText || ''} ${addressText || ''}`.toLowerCase();
    return (
      /\b2\s*-\s*3 days?\b|\b3\s*-\s*4 days?\b|\b4\s*-\s*5 days?\b|\b4\s*-\s*6 days?\b|mumbai|hyderabad|goa|bangalore|bengaluru|new delhi|delhi|ncr|india/.test(combined) &&
      !combined.includes('pune') &&
      !combined.includes('pimpri') &&
      !combined.includes('chinchwad') &&
      !combined.includes('pcmc')
    );
  };

  const resolveDeliveryState = () => {
    const saved = getSavedLocation();
    const puneWindow = getPuneDeliveryWindow();

    if (
      window.RufftailDeliveryEta &&
      typeof window.RufftailDeliveryEta.getCurrentDisplay === 'function'
    ) {
      const display = window.RufftailDeliveryEta.getCurrentDisplay();
      if (display && display.time) {
        return {
          title: display.time,
          subtitle: display.note || puneWindow.note
        };
      }
    }

    if (saved) {
      const eta = saved.time || saved.eta_text || saved.delivery_time || defaultMinutes;
      const address =
        saved.address ||
        saved.locality ||
        saved.label ||
        saved.city ||
        defaultCity;

      if (isPuneDeliveryText(eta, address) && !isNonPuneDayEta(eta, address)) {
        if (isOuterPuneDeliveryText(eta, address)) {
          return {
            title: 'Delivery in 2-3 days',
            subtitle: 'Delivery timeline based on your saved location.'
          };
        }

        return {
          title: puneWindow.title,
          subtitle: puneWindow.note
        };
      }

      return {
        title: `Delivering to ${address} in ~${eta}`,
        subtitle: 'Delivery timeline based on your saved location.'
      };
    }

    const headerEta =
      document.querySelector('#rf-delivery-time')?.textContent?.trim() ||
      document.querySelector('#rf-delivery-time-m')?.textContent?.trim();
    const headerAddress =
      document.querySelector('#rf-address')?.textContent?.trim() ||
      document.querySelector('#rf-address-m')?.textContent?.trim();

    if (headerEta && headerAddress && !/check (fast )?delivery/i.test(headerEta)) {
      if (isPuneDeliveryText(headerEta, headerAddress) && !isNonPuneDayEta(headerEta, headerAddress)) {
        if (isOuterPuneDeliveryText(headerEta, headerAddress)) {
          return {
            title: 'Delivery in 2-3 days',
            subtitle: 'Delivery timeline synced with the header location selector.'
          };
        }

        return {
          title: puneWindow.title,
          subtitle: puneWindow.note
        };
      }

      return {
        title: `Delivering to ${headerAddress} in ~${headerEta}`,
        subtitle: 'Delivery timeline synced with the header location selector.'
      };
    }

    return {
      title: 'Check delivery time',
      subtitle: 'Enter pincode or use live location.'
    };
  };

  const renderDeliveryState = () => {
    const state = resolveDeliveryState();
    if (deliveryTitle) deliveryTitle.textContent = state.title;
    if (deliverySubtitle) deliverySubtitle.textContent = state.subtitle;
  };

  const getCartQtyMap = (cart) => {
    const qtyMap = {};
    if (!cart || !Array.isArray(cart.items)) return qtyMap;

    cart.items.forEach((item) => {
      qtyMap[String(item.variant_id)] = item.quantity;
    });

    return qtyMap;
  };

  const updateHeaderCartCount = (itemCount) => {
    const badges = document.querySelectorAll('.rf-cart-badge, .rt-home__cart-count');
    badges.forEach((badge) => {
      badge.textContent = itemCount;
    });

    const stickyCartBtn = home.querySelector('[data-sticky-cart-btn]');
    if (stickyCartBtn) {
      stickyCartBtn.textContent = itemCount > 0 ? `View cart (${itemCount})` : 'View cart';
    }
  };

  const updateStickyState = (total, itemCount) => {
    if (!stickyBar) return;

    const hasItems = itemCount > 0;
    stickyBar.hidden = !hasItems;
    home.classList.toggle('has-sticky-cart', hasItems);

    if (!hasItems) return;

    if (stickyTitle) {
      stickyTitle.textContent = itemCount === 1 ? '1 item in cart' : `${itemCount} items in cart`;
    }

    if (stickyText) {
      const centralDisplay =
        window.RufftailDeliveryEta &&
        typeof window.RufftailDeliveryEta.getCurrentDisplay === 'function'
          ? window.RufftailDeliveryEta.getCurrentDisplay(total)
          : null;
      const deliveryWindow = centralDisplay && centralDisplay.time
        ? { title: centralDisplay.time, note: centralDisplay.note || getPuneDeliveryWindow().note }
        : getPuneDeliveryWindow();
      stickyText.textContent =
        typeof total === 'number' && total > 0
          ? `${formatINR(total)} ready for ${deliveryWindow.title.toLowerCase()}.`
          : `${deliveryWindow.title}. ${deliveryWindow.note}`;
    }
  };

  const renderQtyControls = (cart) => {
    const qtyMap = getCartQtyMap(cart);

    home.querySelectorAll('[data-product-card]').forEach((card) => {
      const variantId = String(card.dataset.variantId || '');
      const qty = Number(qtyMap[variantId] || 0);

      const addWrap = card.querySelector('[data-add-wrap]');
      const qtyWrap = card.querySelector('[data-qty-wrap]');
      const qtyValue = card.querySelector('[data-qty-value]');

      if (qty > 0) {
        if (addWrap) addWrap.hidden = true;
        if (qtyWrap) qtyWrap.hidden = false;
        if (qtyValue) qtyValue.textContent = qty;
      } else {
        if (addWrap) addWrap.hidden = false;
        if (qtyWrap) qtyWrap.hidden = true;
        if (qtyValue) qtyValue.textContent = '0';
      }
    });
  };

  const fetchCart = async () => {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) {
      throw new Error('Unable to fetch cart');
    }

    return response.json();
  };

  const syncCartUI = async () => {
    try {
      const cart = await fetchCart();
      updateStickyState((cart.total_price || 0) / 100, cart.item_count || 0);
      updateHeaderCartCount(cart.item_count || 0);
      renderQtyControls(cart);
    } catch (error) {
      console.error(error);
    }
  };

  const addVariantToCart = async (variantId, button, properties = {}) => {
    if (!variantId || !button) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1,
          properties
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add item');
      }

      button.textContent = 'Added';
      syncCartUI();

      window.setTimeout(() => {
        button.disabled = false;
        button.textContent = originalText;
      }, 500);
    } catch (error) {
      console.error(error);
      button.disabled = false;
      button.textContent = originalText;
    }
  };

  const updateCartItemQuantity = async (variantId, quantity, triggerButton) => {
    if (!variantId) return;

    if (triggerButton) triggerButton.disabled = true;

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          updates: {
            [Number(variantId)]: Math.max(0, quantity)
          }
        })
      });

      if (!response.ok) {
        throw new Error('Failed to update quantity');
      }

      const cart = await response.json();
      updateStickyState((cart.total_price || 0) / 100, cart.item_count || 0);
      updateHeaderCartCount(cart.item_count || 0);
      renderQtyControls(cart);
    } catch (error) {
      console.error(error);
    } finally {
      if (triggerButton) triggerButton.disabled = false;
    }
  };

  const closeVariantModal = () => {
    if (!variantModal) return;
    variantModal.hidden = true;
    document.body.classList.remove('rt-home-modal-open');
    if (variantList) variantList.innerHTML = '';
    if (variantTitle) variantTitle.textContent = '';
  };

  const openVariantModal = (button) => {
    if (!variantModal || !variantList) return;

    let variants = [];
    try {
      variants = JSON.parse(button.dataset.variants || '[]');
    } catch (error) {
      variants = [];
    }

    if (!variants.length) return;

    if (variantTitle) {
      variantTitle.textContent = button.dataset.productTitle || 'Choose variant';
    }

    variantList.innerHTML = variants.map((variant) => {
      const soldOut = !variant.available;
      return `
        <button
          type="button"
          class="rt-home__variant-option${soldOut ? ' is-disabled' : ''}"
          data-variant-option
          data-variant-id="${variant.id}"
          ${soldOut ? 'disabled' : ''}
        >
          <span>${variant.title === 'Default Title' ? 'Default' : variant.title}</span>
          <strong>${variant.price}</strong>
        </button>
      `;
    }).join('');

    variantList.querySelectorAll('[data-variant-option]').forEach((option) => {
      option.addEventListener('click', () => {
        addVariantToCart(option.dataset.variantId, button);
        closeVariantModal();
      });
    });

    variantModal.hidden = false;
    document.body.classList.add('rt-home-modal-open');
  };

  renderDeliveryState();
  syncCartUI();

  document.addEventListener('rufftail:location-updated', renderDeliveryState);
  window.addEventListener('storage', renderDeliveryState);

  home.querySelectorAll('[data-home-add]').forEach((button) => {
    button.addEventListener('click', () => {
      const hasVariants = button.dataset.hasVariants === 'true';

      if (hasVariants) {
        openVariantModal(button);
        return;
      }

      addVariantToCart(button.dataset.variantId, button);
    });
  });

  home.querySelectorAll('[data-qty-minus]').forEach((button) => {
    button.addEventListener('click', async () => {
      const card = button.closest('[data-product-card]');
      const qtyValue = card?.querySelector('[data-qty-value]');
      const currentQty = Number(qtyValue?.textContent || 0);
      await updateCartItemQuantity(button.dataset.variantId, currentQty - 1, button);
    });
  });

  home.querySelectorAll('[data-qty-plus]').forEach((button) => {
    button.addEventListener('click', async () => {
      const card = button.closest('[data-product-card]');
      const qtyValue = card?.querySelector('[data-qty-value]');
      const currentQty = Number(qtyValue?.textContent || 0);
      await updateCartItemQuantity(button.dataset.variantId, currentQty + 1, button);
    });
  });

  home.querySelectorAll('[data-variant-close]').forEach((node) => {
    node.addEventListener('click', closeVariantModal);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeVariantModal();
    }
  });

  home.querySelectorAll('.rt-home__hero-card[data-href]').forEach((card) => {
    card.style.cursor = 'pointer';

    card.addEventListener('click', () => {
      const url = card.dataset.href;
      const target = card.dataset.target || '_self';

      if (!url) return;

      if (target === '_blank') {
        window.open(url, '_blank', 'noopener');
      } else {
        window.location.href = url;
      }
    });
  });

  const heroSlider = home.querySelector('[data-hero-slider]');
  const heroTrack = heroSlider?.querySelector('.rt-home__hero-track');
  const heroDots = heroSlider ? Array.from(heroSlider.querySelectorAll('.rt-home__hero-dot')) : [];

  if (heroTrack) {
    let index = 0;
    const slides = Array.from(heroTrack.children);

    const updateDots = (activeIndex) => {
      heroDots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === activeIndex);
      });
    };

    if (slides.length > 1) {
      window.setInterval(() => {
        index = (index + 1) % slides.length;
        heroTrack.scrollTo({
          left: slides[index].offsetLeft,
          behavior: 'smooth'
        });
        updateDots(index);
      }, 4200);

      heroTrack.addEventListener('scroll', () => {
        const nextIndex = slides.findIndex((slide) => {
          return Math.abs(heroTrack.scrollLeft - slide.offsetLeft) < slide.offsetWidth / 2;
        });

        if (nextIndex >= 0) {
          index = nextIndex;
          updateDots(index);
        }
      });
    }
  }
});
